import { useRef, useState } from "react"
import { FiCopy } from "react-icons/fi"
import { BiCheck} from "react-icons/bi"
interface InputCopyProps {
  text: string,
  value: string,
}

const InputCopy = ({ text, value}:InputCopyProps) => {
  const [copied, setCopied] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  const Copyurl = ()=>{
    let content =  ref.current?.textContent || ''
    navigator.clipboard.writeText(content)
      .then(() => {
        setCopied(true)
        setTimeout(function () { setCopied(false) }, 1000);
      })
      .catch((err) => {
        console.log('Something went wrong', err);
      })
  }
  return (
    <div className="c-link-url">
      <span className="c-link-url__title">{text}</span>
      <div className="c-link-url__content">
        <div className="c-link-url__input" ref={ref}>
          {value}
        </div>

        {
          copied ?
          <div className="c-link-url__box-copied">
            Copied <BiCheck />
          </div>
          :
          <div className="c-link-url__box-copy" onClick={Copyurl}>
            <FiCopy />Copy
          </div>
        }


      </div>
    </div>
  )
}

export default InputCopy